var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"main-header",style:(_vm.headerBg)},[_c('h1',{staticClass:"header-logo"},[_c('a',[_c('img',{attrs:{"src":_vm.headerLogoUrl,"alt":"AkaDakoグラフ"}})])]),(_vm.showConnectStatusOnHeader)?_c('ConnnectStatus'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }